import { flatten, includes, isNil, map, mapValues, pick } from 'lodash'

import {
  INGREDIENT_KEYWORD_TYPES,
  PROJECT_SOURCES,
} from '../../../common/constants'
import { isDbId } from '../../../common/utils'

const propsForSaving = [
  'id',
  'parentId',
  'term',
  'type',
  'subtype',
  'source',
  'languageId',
]

const transformKeywordTreeToSaveArgs = (ingredientId, treeData) =>
  map(treeData, node => {
    const directChildrenFromSubtypeNodes = flatten(
      map(node.children, ({ children }) =>
        map(children, childNode => ({ ...childNode, parentId: node.id })),
      ),
    )

    return {
      ...pick(node, propsForSaving),
      suggestedType: includes(
        [
          INGREDIENT_KEYWORD_TYPES.SYNONYMS.id,
          INGREDIENT_KEYWORD_TYPES.VARIETIES.id,
        ],
        node.type,
      )
        ? null
        : node.suggestedType,
      ingredientId,
      source:
        isDbId(node.id) && !isNil(node.source)
          ? node.source
          : PROJECT_SOURCES.METADATA,
      isName: isNil(node.isName) ? false : node.isName,
      children: transformKeywordTreeToSaveArgs(
        ingredientId,
        directChildrenFromSubtypeNodes,
      ),
    }
  })

const transformToUpdateIngredientKeywordsArgs = (ingredientId, data) =>
  mapValues(data, treeData =>
    transformKeywordTreeToSaveArgs(
      ingredientId,
      map(treeData[0].children, root => ({ ...root, parentId: null })),
    ),
  )

export default transformToUpdateIngredientKeywordsArgs
